<template>
  <lw-overlay
    :size="'c1'"
    :close="false">
    <div class="grid grid-columns-4_md">
      <div class="grid-column-start-2_md grid-column-end-4_md flex flex-column justify-items-center vh75">
        <h1 class="mb2">Are you sure your want to archive <br><span class="accent-text">{{ name }}</span>?</h1>
        <div class="flex">
          <button
            class="mr1 large-button grey-button"
            @click.prevent="cancel">No. I want to keep this red flag</button>
          <button
            class="dark-red-button large-button"
            @click.once.prevent="archive">Yes. Archive this red flag</button>
        </div>
      </div>
    </div>
  </lw-overlay>
</template>

<script>
import Overlay from '../livewires/Overlay'

export default {
  components: {
    lwOverlay: Overlay
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    page: {
      type: String,
      default: ''
    }
  },
  methods: {
    cancel () {
      this.$emit('update:isConfirming', false)
    },
    archive () {
      this.$store.dispatch('saveState', false)
      this.$store.dispatch('archiveRedFlag', this.page)
      this.$router.push({ name: 'redflags', query: { alert: this.name, type: 'success', action: 'archived' } })
    }
  }
}
</script>
